import React from 'react';
import PropTypes from 'prop-types';
import Loader from '~/components/Loader/Loader';

const PageOverlay = props => {
    const { show, text, spinner } = props;
    if (show) {
        return (
            <div className="overlay d-block">
                <div
                    className={`center text-center ${
                        text ? 'has' : 'no'
                    }-message`}
                >
                    {spinner}
                    {text ? <h5 className="pt-2">{text}</h5> : null}
                </div>
            </div>
        );
    } else {
        return null;
    }
};

PageOverlay.propTypes = {
    spinner: PropTypes.object,
    show: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

PageOverlay.defaultProps = {
    spinner: <Loader />,
    show: false,
    text: null
};

export default PageOverlay;
